import { render } from "./ColumnsConfigModal.vue?vue&type=template&id=72c77035&scoped=true"
import script from "./ColumnsConfigModal.vue?vue&type=script&lang=js"
export * from "./ColumnsConfigModal.vue?vue&type=script&lang=js"

import "./ColumnsConfigModal.vue?vue&type=style&index=0&id=72c77035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c77035"]])

export default __exports__